import defineApi from '../define-api'
import http from '../application-api'

export const getAppVersion = defineApi((config) => {
  return http.load('/version', config)
})

